import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,

  // base switch transform + checked track color
  '& .MuiSwitch-switchBase': {
    margin: 1,
    padding: 0,
    transform: 'translateX(6px)',
    '&.Mui-checked': {
      color: '#fff',
      transform: 'translateX(28px)',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#da8a58',
      },
    },
  },

  // ensure checked thumb specifically (higher specificity)
  '& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb': {
    backgroundColor: '#da8a58 !important',
  },

  // thumb: always orange circle; remove any pseudo-icons
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 28,
    height: 28,
    backgroundColor: '#da8a58 !important',
    borderRadius: '50%',
    boxShadow: 'none',
  },

  // remove any ::before/icon that might fill the thumb
  '& .MuiSwitch-thumb::before': {
    backgroundImage: 'none !important',
    content: "''",
  },

  // unchecked track color (subtle)
  '& .MuiSwitch-track': {
    opacity: 1,
    backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
    borderRadius: 20 / 2,
  },
}));

export default function ThemeSwitch() {
  return <MaterialUISwitch />;
}